export const isMIMETypeVideo = (type: string) => ['video/mp4', 'video/x-msvideo', 'video/mpeg', 'video/quicktime', 'video/x-flv', 'video/x-ms-wmv', 'video/webm', 'video/x-matroska', 'video/ogg']
    .includes(type);
